import * as Application from "expo-application";
import { Platform } from "react-native";
import { createMMKV } from "react-native-mmkv";
import uuid from "react-native-uuid";

const store = createMMKV({ id: "playSessionDevice" });
// A new key deliberately avoids adopting a v1 analytics SDK identity.
const KEY = "webDeviceIdV2";
let resolving: Promise<string> | undefined;
export function getPlayDeviceId(): Promise<string> {
  resolving ??= resolve().finally(() => {
    resolving = undefined;
  });
  return resolving;
}
async function resolve(): Promise<string> {
  if (Platform.OS === "android") return Application.getAndroidId();
  if (Platform.OS === "ios") {
    const id = await Application.getIosIdForVendorAsync();
    // iOS may temporarily return null before the first unlock; retry in the hook.
    if (!id) throw new Error("vendor_id_unavailable");
    return id;
  }
  const id = store.getString(KEY) || uuid.v4();
  store.set(KEY, id);
  return id;
}
export function resetPlayDeviceIdForTests() {
  store.remove(KEY);
  resolving = undefined;
}
